import React, { useState } from 'react';
import FundWalletModal from 'components/modals/fund-wallet-modal';
import { formatCurrency } from 'utils/functions';
import TopUpEventWalletModal from 'components/modals/topup-event-wallet-modal';
import { ReactComponent as ToolTipIcon } from 'assets/icons/tooltip.svg';
import { Dropdown } from '@cokitchen/cokitchen-components';

type Props = {
  balance?: string;
  budget?: string;
  loading?: boolean;
  orders?: string;
  afterPayment?: (args?: any) => any;
  walletType?: 'events' | 'company';
  userId?: string;
  eventId?: string;
  spent_percentage?: string;
  amount_spent?: string;
  refetchData?: () => Promise<void>;
};

const MainDashboard = ({
  balance,
  budget,
  loading,
  userId,
  eventId,
  walletType = 'company',
  spent_percentage,
  amount_spent,
  refetchData
}: Props) => {
  const [showAddMoneyModal, setShowAddMoneyModal] = useState(false);
  const [showTopupWalletModal, setShowTopupWalletModal] = useState(false);
  const topUpEvent = () => {
    setShowTopupWalletModal(!showTopupWalletModal);
    refetchData?.();
  };

  const topUp = () => {
    setShowAddMoneyModal(!showAddMoneyModal);
  };

  const data = [
    {
      title: `Wallet Balance`,
      value: (
        <div>
          <p className='text-white md:text-[20px] lg:text-[32px] sm:text-[20px] font-semibold'>
            <small className='text-[10px] font-medium'>NGN</small>
            {balance
              ? formatCurrency(
                  balance,
                  {
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                    style: 'decimal'
                  },
                  true
                )
              : ' -'}
            {balance && parseFloat(balance) >= 10000000 && (
              <div className='inline-block pl-1'>
                <Dropdown placement='right' className='w-[200px]' tooltip content={<ToolTipIcon />}>
                  <div className='w-[200px] text-gray-5 p-2 bg-white border border-gray-1 rounded'>
                    The figure displayed was rounded up. The actual wallet balance is{' '}
                    {formatCurrency(balance)}
                  </div>
                </Dropdown>
              </div>
            )}
          </p>
        </div>
      ),
      style: 'bg-wallet-minus bg-[#141415] text-[#D9D9D9] ',
      color: 'text-white',
      addMoney: true
    },
    ...(amount_spent
      ? [
          {
            title: 'Amount spent so far',
            value: (
              <p className='md:text-[20px] lg:text-[32px]  sm:text-[20px] font-semibold '>
                <small className='text-[10px] font-medium'>NGN</small>
                {amount_spent
                  ? formatCurrency(
                      amount_spent,
                      {
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                        style: 'decimal'
                      },
                      true
                    )
                  : ' -'}
                {amount_spent && parseFloat(amount_spent) >= 10000000 && (
                  <div className='inline-block pl-1'>
                    <Dropdown
                      placement='right'
                      className='w-[200px]'
                      tooltip
                      content={<ToolTipIcon />}>
                      <div className='w-[200px] text-gray-5 p-2 bg-white border border-gray-1 rounded'>
                        The figure displayed was rounded up. The amount spent is{' '}
                        {formatCurrency(amount_spent)}
                      </div>
                    </Dropdown>
                  </div>
                )}
              </p>
            ),
            style: 'bg-amount-spent bg-[#F8F7F7] ',
            deviation: spent_percentage ? Number(spent_percentage) : 0,
            subText: (
              <p className='md:mb-0 mb-3 md:absolute bottom-4 text-[#6F7376] text-[10px] md:text-xs'>
                Your budget is&nbsp;
                <span className='text-medium '>
                  {budget
                    ? formatCurrency(budget, {
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0
                      })
                    : ' -'}
                </span>
              </p>
            )
          }
        ]
      : [])
  ];

  return (
    <div className={data.length > 1 ? 'md:grid grid-cols-2 gap-4' : ''}>
      {data?.map(
        ({ title, value, style, color, deviation, addMoney, subText }: any, index: number) => (
          <div
            key={index}
            className={`${style} md:my-0 my-4 flex flex-col relative bg-no-repeat bg-right  text-[#6F7376] border border-[#F0EFEF] pl-[30px]  pt-[30px]  rounded-[8px]`}>
            <div className='flex items-center gap-[6px] text-xs md:text-sm text-[#6F7376]'>
              <p>{title}</p>
              {deviation ? (
                <p className='w-fit bg-[#3FB827] rounded-full text-white px-[7px] text-xs py-[2px]'>
                  {`+${deviation}%`}
                </p>
              ) : (
                <span />
              )}
            </div>
            <p className={`${color} text-[#2E3031] font-extrabold block h-[48px]`}>{value}</p>
            {addMoney && (
              <button
                onClick={() => (walletType === 'events' ? topUpEvent() : topUp())}
                className='py-2 px-5 rounded inline-block w-fit bg-[#232325] text-white mb-[18px] mt-[10px] text-xs mr-7'>
                + Add Money
              </button>
            )}
            {subText && <p>{!loading && subText}</p>}
          </div>
        )
      )}

      <TopUpEventWalletModal
        isOpen={showTopupWalletModal}
        onClose={topUpEvent}
        userId={userId}
        eventId={eventId}
      />
      <FundWalletModal isOpen={showAddMoneyModal} onClose={topUp} />
    </div>
  );
};

export default MainDashboard;
